import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} Made by Ayka Imran :)</p>
    </footer>
  );
}

export default Footer;
